import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
//import methods from '../utils/api/RefService';
import { GedService } from "../api/GedService";
import { ProjectStatusService } from "../api/ProjectStatusService";

import {
  GedSharepointListItem,
  WorkspaceResponse,
  AccessSharepointListItem,
  AccessResponse, 
  RequestProjectWorkspaceStore,
  RequestProjectAccessStore,
  UpdateWorkspaceStatusStore,
  GetWorkspaceStatusStore,
  WorkspaceStatusResponse,
  SharepointStatus,
  UpdateWorkspaceResponse
} from "../models/SharePointTypes";


export const StoreRequestProjectWorkspace = create(
  persist<RequestProjectWorkspaceStore>(
    (set) => ({
      isLoading: false,
      isFinished: false,
      requestProjectWorkspace: async (
        project_id: number,
        data: GedSharepointListItem
      ) => {
        try {
          set({ isLoading: true, isFinished: false });
          const response: WorkspaceResponse =
            await GedService.requestProjectWorkspace(project_id, data);
          set(() => ({
            isLoading: false,
            responseRequestProjectWorkspace: response,
            isFinished: true,
          }));
        } catch (err: any) {
          const errorRequestProjectWorkspace =
            err?.message || err?.data?.message || "Unexpected network error.";
          set(() => ({
            isLoading: false,
            errorRequestProjectWorkspace,
            isFinished: false,
          }));
        }
      },
    }),
    {
      name: "request-workspace-store",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export const StoreRequestProjectAccess = create(
  persist<RequestProjectAccessStore>(
    (set) => ({
      isLoading: false,
      isFinished: false,
      requestProjectAccess: async (
        project_id: number,
        data: AccessSharepointListItem
      ) => {
        try {
          set({ isLoading: true, isFinished: false });
          const response: AccessResponse =
            await GedService.requestProjectAccess(project_id, data);
          set(() => ({
            isLoading: false,
            responseRequestProjectAccess: response,
            isFinished: true,
          }));
        } catch (err: any) {
          const errorRequestProjectAccess =
            err?.message || err?.data?.message || "Unexpected network error.";
          set(() => ({
            isLoading: false,
            errorRequestProjectAccess,
            isFinished: false,
          }));
        }
      },
    }),
    {
      name: "request-access-store",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
export const StoreUpdateWorkspaceStatus = create(
  persist<UpdateWorkspaceStatusStore>(
    (set) => ({
      isLoading: false,
      isFinished: false,
      updateWorkspaceStatus: async (
        project_id: number,
        status: SharepointStatus
      ) => {
        try {
          set({ isLoading: true, isFinished: false });
          const response: UpdateWorkspaceResponse =
            await ProjectStatusService.updateWorkspaceStatus(project_id, status);
          set(() => ({
            isLoading: false,
            responseUpdateWorkspaceStatus: response,
            isFinished: true,
          }));
        } catch (err: any) {
          const errorUpdateWorkspaceStatus =
            err?.message || err?.data?.message || "Unexpected network error.";
          set(() => ({
            isLoading: false,
            errorUpdateWorkspaceStatus,
            isFinished: false,
          }));
        }
      },
    }),
    {
      name: "update-workspace-store",
      storage: createJSONStorage(() => localStorage),
    }
  )
)

export const StoreGetWorkspaceStatus = create(
  persist<GetWorkspaceStatusStore>(
    (set) => ({
      isLoading: false,
      isFinished: false,
      getWorkspaceStatus: async (
        project_id: number
      ) => {
        try {
          set({ isLoading: true, isFinished: false });
          const response: WorkspaceStatusResponse =
            await ProjectStatusService.getSharepointWorkspaceStatus(project_id);
          set(() => ({
            isLoading: false,
            responseGetWorkspaceStatus: response,
            isFinished: true,
          }));
        } catch (err: any) {
          const errorGetWorkspaceStatus =
            err?.message || err?.data?.message || "Unexpected network error.";
          set(() => ({
            isLoading: false,
            errorGetWorkspaceStatus,
            isFinished: false,
          }));
        }
      },
    }),
    {
      name: "get-workspace-status-store",
      storage: createJSONStorage(() => localStorage),
    }
  )  
);
